import React, { useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useAppSelector } from "@/hooks";

import Input from "@/components/Atoms/Inputs/Input";
import CountryDropdown from "@/components/Atoms/Inputs/CountryDropdown";
import Image from "@/components/Atoms/Image";
import ErrorUI from "@/components/Atoms/ErrorUI";
import { formatOptionLabelV2 } from "@/components/Molecules/FormatOptionLabel/V2";

import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";
import { isValidMobile, matchCountryRegex } from "@/utils";

import {
  ArrowDown,
  CountryPlaceholder,
  DropDown,
  InputWrap,
  NumberPlaceholder,
  PhoneFlag,
  PhoneIcon,
} from "./style";
import { InputGroup, InputWrapper } from "../style";

const PhoneInput = ({
  name,
  control,
  showLabels,
  mobilePlaceholder,
  inputFontSize,
  inputLineHeight,
  showPhoneIcon = false,
  handleBlur,
}) => {
  const { countryCodeData: countryCodes } = useAppSelector(
    (state) => state.dashboard
  );
  const [showCountryDropDown, setShowCountryDropDown] = useState(false);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowCountryDropDown(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [ref]);
  }

  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef);

  const { getValues } = useFormContext();
  const values = getValues();

  return (
    <InputWrapper>
      <InputGroup hasBottomBorder showLabels={showLabels}>
        <InputWrap>
          <Controller
            name={`${name}CountryCode`}
            control={control}
            shouldUnregister
            render={({ field: { value, onChange, ref }, formState: {} }) => (
              <CountryPlaceholder showCountryDropDown={showCountryDropDown}>
                <NumberPlaceholder
                  onClick={() => setShowCountryDropDown(!showCountryDropDown)}
                  position="relative"
                >
                  {!showPhoneIcon &&
                  (value === "+91" ||
                    value === "+971" ||
                    value === "+974" ||
                    value === "+1" ||
                    value === "+65" ||
                    value === "+44") ? (
                    <PhoneFlag height="16px" width="24px">
                      <Image
                        maxWidth="24px"
                        maxHeight="16px"
                        imageName={`flags/${
                          value === "+91"
                            ? "india.png"
                            : value === "+971"
                            ? "uae.png"
                            : value === "+974"
                            ? "qatar.png"
                            : value === "+1"
                            ? "usa.png"
                            : value === "+65"
                            ? "singapore.png"
                            : value === "+44" && "uk.png"
                        }`}
                        alt="flag"
                      />
                    </PhoneFlag>
                  ) : (
                    <PhoneIcon
                      icon="icon-phone-2"
                      fill={theme.colorsV2.gray.shade_700}
                      height="16px"
                      width="16px"
                    />
                  )}
                  <Typography
                    variant="label2"
                    color={theme.colorsV2.gray.shade_700}
                    width="100%"
                    textAlign="center"
                  >
                    {value}
                  </Typography>
                  <ArrowDown
                    icon="icon-caret-down"
                    fill={theme.colorsV2.gray.shade_700}
                    height="8px"
                    width="8px"
                  />
                </NumberPlaceholder>
                <DropDown
                  showCountryDropDown={showCountryDropDown}
                  ref={wrapperRef}
                >
                  {/* FATAL "check for element which are not from yup" */}
                  <CountryDropdown
                    menuIsOpen={showCountryDropDown}
                    options={countryCodes?.list}
                    formatOptionLabel={formatOptionLabelV2}
                    wrapperClassName="shyftList"
                    dropDownHeight="180px"
                    placeholder="Search"
                    defaultValue={value}
                    onChange={(countryCode) => {
                      onChange(countryCode.code);
                      setShowCountryDropDown(false);
                    }}
                    closeMenuOnSelect
                    variant="v2"
                  />
                </DropDown>
              </CountryPlaceholder>
            )}
          />
          <Controller
            name={name}
            control={control}
            shouldUnregister
            render={({
              field: { value, onBlur, onChange, ref },
              fieldState: { error },
              formState: { errors },
            }) => (
              <>
                <Input
                  ref={ref}
                  inputPadding="3px 16px 3px 100px"
                  type="text"
                  placeholder={mobilePlaceholder}
                  pattern="[0-9]*"
                  inputMode="decimal"
                  name={name}
                  value={value}
                  onChange={(e) => {
                    if (
                      e.target.value === "" ||
                      isValidMobile(e.target.value)
                    ) {
                      onChange(e);
                    }
                  }}
                  onBlur={(e) => {
                    onBlur(e).then((e) => {
                      const isValidNumber = matchCountryRegex(
                        values?.[`${name}CountryCode`],
                        value
                      );
                      if (!errors?.[name] && isValidNumber) handleBlur(e);
                    });
                  }}
                  autoComplete="off"
                  variant="v2"
                  inputFontSize={inputFontSize}
                  inputLineHeight={inputLineHeight}
                />
                {error && <ErrorUI hasBottomBorder error={error?.message} />}
              </>
            )}
          />
        </InputWrap>
      </InputGroup>
    </InputWrapper>
  );
};

export default PhoneInput;
